import React, {Component, Fragment} from "react";
import {Select} from '@material-ui/core';
import PhoneNumber from "awesome-phonenumber";
import Div100vh from "../../../../uq-ui/components/div-100"
import LayoutComponentsHeader from "../../../../layout/ui/components/header";
import UQFormsTextField from "../../../../uq-forms/components/text-field";
import * as styles from "./style.css";
import UQButton from "../../../../uq-ui/components/button";
import eCommerceSmsResource from "../../../domin/resources/ECommerceSmsResource";


const countries = {
  IL: {value: "IL", display: "IL (+972)"},
  US: {value: "US", display: "US (+1)"},
  UK: {value: "UK", display: "UK (+44)"},
};

class Test extends Component {
  state = {
    countryCode: countries.IL.value,
    phoneNumberInput: "",
    phoneNumber: null,
    phoneNumberError: null,
    error: null
  };

  handleNumberUpdate = (event) => {
    const value = event.target.value;
    const phoneNumber = new PhoneNumber(value, this.state.countryCode);
    this.setState({
      error: null,
      phoneNumberInput: value,
      phoneNumber: phoneNumber.getNumber(),
      phoneNumberError: !phoneNumber.isValid() ? "Invalid phone number" : null
    });
  };

  _getStickerId = () => {
    return this.props.location && this.props.location.state && this.props.location.state.stickerId;
  };

  goToStickerScan = () => {
    this.props.history.push('/business/scan-sticker');
  };

  onSend = () => {
    eCommerceSmsResource.create({
      sticker_id: this._getStickerId(),
      phone_number: this.state.phoneNumber
    }).then(() => {
      this.goToStickerScan();
    }).catch((error) => {
      this.setState({error: "Error sending SMS"})
    })
  };

  render() {
    if (!this._getStickerId()) {
      this.goToStickerScan();
    }

    const buttonDisabled = !this.state.phoneNumberInput || this.state.phoneNumberError;
    return (
      <Fragment>
        <LayoutComponentsHeader/>
        <Div100vh className={styles.page} style={{minHeight: '100rvh'}}>
          <div className={styles.header}>
            <div className={`${styles.title} font-title`}
                 dangerouslySetInnerHTML={{__html: "Please enter phone number"}}/>
          </div>
          <div className={styles.header}>
            <div className={`${styles.subTitle} font-text`}
                 dangerouslySetInnerHTML={{__html: "Llama Number: " + this._getStickerId()}}/>
          </div>
          <div style={{width: "100%", height: "100px", marginTop: 50}}>
            <div style={{display: "flex", justifyContent: "center",}}>
              <div style={{marginTop: "17px", marginBottom: "8px"}}>
                <Select
                  native
                  value={this.state.countryCode}
                  onChange={(event) => this.setState({countryCode: event.target.value})}
                  inputProps={{id: 'outlined-age-native-simple', className: styles.label}}
                >
                  {Object.values(countries).map((country) => <option value={country.value}>{country.display}</option>)}
                </Select>
              </div>
              <div>
                <UQFormsTextField
                  id="standard-bare"
                  placeholder={"Type here..."}
                  onChange={this.handleNumberUpdate}
                  error={this.state.phoneNumberError}
                />
              </div>
            </div>
            <div className={styles.errorContainer}>
              {this.state.error ? this.state.error : ""}
            </div>
          </div>
          <div style={{display: "flex", justifyContent: "center"}}>
            <UQButton
              theme={"whiteBrand"}
              label={"BACK"}
              onPress={this.goToStickerScan}
              containerStyle={{marginRight: "20px"}}
            />
            <UQButton
              label={"SEND"}
              disabled={buttonDisabled}
              onPress={this.onSend}
            />
          </div>
        </Div100vh>
      </Fragment>
    )
  }
}

export default Test;



// WEBPACK FOOTER //
// ./src/app/modules/business/ui/screens/send-link-by-sms/index.jsx